import React, { useState, useEffect } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { TfiMenuAlt } from 'react-icons/tfi'
import { PiChartBar } from 'react-icons/pi'
import { SlBookOpen } from 'react-icons/sl'
import { AiFillYoutube } from 'react-icons/ai'
import { VscKebabVertical } from 'react-icons/vsc'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { RiDeleteBinLine } from "react-icons/ri"
import { GoSearch } from 'react-icons/go'
import { BiPlusCircle, BiTime } from 'react-icons/bi'
import AddRoundedIcon from '@mui/icons-material/AddRounded'

import { MdKeyboardArrowDown } from 'react-icons/md'
import "./css/LeadsPipeView.css"
import LeadInformation from '../components/LeadInformation'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import LeadsView from '../components/LeadsView'
import axios from "axios"
import api from "../config/backend"
import { useOutletContext } from 'react-router-dom'
import { toast } from 'react-toastify'
import AddLead from './AddLead'
import { Scrollbar } from 'react-scrollbars-custom'
import { Button, IconButton, Tooltip } from '@mui/material'
import { BadgeOutlined, BusinessOutlined, Close, Delete, DeleteForeverOutlined, DeleteOutline, Edit, HighlightOffOutlined, PlusOneOutlined } from '@mui/icons-material'
import { BsEye } from 'react-icons/bs'
import ceo from '../assets/DefaultProfileCircle.jpg'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import UpdateLead from './UpdateLead'



const LeadsPipeView = () => {

    const [triggerRefresh, setTriggerRefresh, searchLead] = useOutletContext()
    const [popupHash, setPopupHash] = useState(undefined)

    console.log(triggerRefresh)

    const Data = [{
        title: "Discovery",
        color: "rgb(250, 216, 207)",
        cost: "$232,332",
        initial: "p",
        name: "pranathi",
        company: "vibho",
        designation: "front-end",
        time: "2 hours ago",
    },
    {

        title: "Qualified",
        color: "rgb(251, 226, 196)",

    },
    {
        title: "In Conversation",
        color: "rgb(206, 202, 240)",

    },
    {
        title: "Closed Won",
        color: "rgb(199, 223, 214)",

    },
    {
        title: "Lost",
        color: "rgb(219, 182, 162)",

    },
    ]
    const availableColors = [
        "rgb(0, 200, 200)",
        "rgb(250, 216, 207)",
        "rgb(251, 226, 196)",
        "rgb(206, 202, 240)",
        "rgb(200, 200, 200)",
    ]

    const [isMenuAltClicked, setIsMenuAltClicked] = useState(false)
    const [isMenuChartClicked, setIsMenuChartClicked] = useState(false)
    const [isAddStageModalOpen, setIsAddStageModalOpen] = useState(false)
    const [newStageName, setNewStageName] = useState('')
    const [data, setdata] = useState(Data)
    const [selectedColor, setSelectedColor] = useState(availableColors[0])
    const [isColorPickerVisible, setIsColorPickerVisible] = useState(false)

    const [editingStageIndex, setEditingStageIndex] = useState(null)
    const [isLeadInfoDrawerOpen, setIsLeadInfoDrawerOpen] = useState(false)
    const [selectedLeadIndex, setSelectedLeadIndex] = useState(null)
    const [stagename, setStageName] = useState([])
    const [isUpdate, setIsUpdate] = useState(false)
    const [editstate, setEditstate] = useState([])
    const [Leadsdata, setLeadsdata] = useState([])
    const [updatingClient, setUpdatingClient] = useState(null)

    const token = localStorage.getItem("_crm__token")
    const [open, setOpen] = useState(false)
    const handleClickOpen = (stagename) => {
        setOpen(true)
        setStageName(stagename)
    }
    const fetchLeads = async () => {
        const { data, status } = await axios.post(`${api}/Leads/fetch-leads`, { token, view: "pipe" })
        console.log({ data })
        if (data.success) {
            setLeadsdata(data.leads)
        } else {
            console.log({ data })
        }
    }


    const handleLeadInfoOpen = (item) => {
        setSelectedLeadIndex(item)
        setIsLeadInfoDrawerOpen(true)
    }

    const handleLeadInfoClose = () => {
        setSelectedLeadIndex(null)
        setIsLeadInfoDrawerOpen(false)
    }

    const handleDeleteStage = async (hash) => {
        if (window.confirm("Are you sure to delete the stage?")) {
            const { data, status } = await axios.post(`${api}/Stages/delete-stage`, { token, hash })

            if (data.success) {
                toast.success(data.message)
                setEditingStageIndex(null)
                setTriggerRefresh(prev => prev + 1)
            } else {
                toast.error(data.message)
            }
        }
    }

    const handleColorSelection = (color) => {
        setSelectedColor(color)
    }
    const handleToggleColorPicker = () => {
        setIsColorPickerVisible(prevState => !prevState)
    }


    const handleMenuAltClick = () => {
        setIsMenuAltClicked(true)
        setIsMenuChartClicked(false)
    }

    const handleChartAltClick = () => {
        setIsMenuChartClicked(true)
        setIsMenuAltClicked(false)
    }

    const addStage = async () => {
        const { data, status } = await axios.post(`${api}/Stages/create-stage`, { token, stage: newStageName, color: selectedColor })

        if (data.success) {
            toast.success(data.message)
            fetchLeads()
            setIsAddStageModalOpen(false)
        } else {
            toast.error(data.message)
        }
    }

    const updateStage = async () => {
        const { data, status } = await axios.post(`${api}/Stages/update-stage`, { token, hash: editstate.hash, name: editstate.stage, color: selectedColor })

        if (data.success) {
            toast.success(data.message)
            fetchLeads()
            setIsAddStageModalOpen(false)
            setEditingStageIndex(null)
        } else {
            toast.error(data.message)
        }
    }

    const deleteLead = async (hash) => {
        if (window.confirm("Are you sure to delete the lead?")) {
            const { data, status } = await axios.post(`${api}/Leads/delete-lead`, { token, hash })

            if (data.success) {
                toast.success(data.message)
                fetchLeads()
            } else {
                toast.error(data.message)
            }
        }
    }

    const handleOpenAddStageModal = () => {
        // setIsUpdate(false)
        setIsAddStageModalOpen(true)
        setNewStageName('')
        setEditingStageIndex(null)
    }

    const handleCloseAddStageModal = () => {
        setIsUpdate(false)
        setIsAddStageModalOpen(false)
    }

    // const handleSaveStage = async () => {
    //     setNewStageName('')
    //     setEditingStageIndex(null)
    //     handleCloseAddStageModal()
    // }

    useEffect(() => {
        fetchLeads()
    }, [triggerRefresh])

    const [anchorE2, setAnchorE2] = React.useState(null)
    const open3 = Boolean(anchorE2)
    const handleClick2 = (event) => {
        setAnchorE2(event.currentTarget)
    }
    const handleClose2 = () => {
        setAnchorE2(null)
    }

    const [anchorEl, setAnchorEl] = React.useState(null)
    const open2 = Boolean(anchorEl)
    const [clickedLeadHash, setClickedLeadHash] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleDrop = async (droppedItem) => {
        if (!droppedItem.destination) return

        const draggableHash = droppedItem.draggableId
        const droppedFromStage = droppedItem.source.droppableId.slice(16,)
        const droppedToStage = droppedItem.destination.droppableId.slice(16,)

        setLeadsdata(prev => {
            const copy = JSON.parse(JSON.stringify(prev))

            const movedLead = copy[droppedFromStage].leads.find(item => item.hash === draggableHash)

            copy[droppedFromStage].leads = copy[droppedFromStage].leads.filter(item => item.hash !== draggableHash)

            copy[droppedToStage].leads.push(movedLead)

            return copy
        })

        const { data, status } = await axios.post(`${api}/Leads/update-lead`, { token, hash: draggableHash, stage: droppedToStage })

        if (data.success === false) {
            console.log({ data })
        }
    }

    const [openUpdateLead, setOpenUpdateLead] = useState(false)
    const [editData, setEditData] = useState()
    const handleClickOpened = () => {
        setOpenUpdateLead(true);
    };

    console.log(searchLead);
    console.log(Leadsdata)
    return (
        <div>
            {editData && <UpdateLead isPopup={openUpdateLead} setPopup={() => {setOpenUpdateLead(false); setEditData(null)}} leadData={editData} setTriggerRefresh={setTriggerRefresh} />}
            <div className='app-component-kanban'>
                {Leadsdata ? Object.keys(Leadsdata).map((stage, index) => {
                    const stagedata = Leadsdata[stage]
               
                    return stagedata.leads.map(item => {
                        // console.log({ t: item })
                        return item.hash === popupHash ? (<SwipeableDrawer
                            anchor="right"
                            open={isLeadInfoDrawerOpen}
                            onClose={handleLeadInfoClose}
                            className='leadsinfo-swipeer'
                        >
                            <LeadInformation
                                leadData={item}
                                availableColors={availableColors}
                                data={data}
                                fetchLeads={fetchLeads}
                                setTriggerRefresh={setTriggerRefresh}
                            />
                        </SwipeableDrawer>) : undefined
                    })

                }) : undefined}
                <DragDropContext onDragEnd={handleDrop}>
                    <ul className='app-component-kanban__list'>
                        {Leadsdata ? Object.keys(Leadsdata).map((stage, index) => {
                            const stagedata = Leadsdata[stage]
console.log(stagedata)
                            return (
                                <li className='app-component-kanban__listitem'>
                                    <div className='app-component-kanban__card'>
                                        <div className='app-component-kanban__card--header'>
                                            <h5 className='app-component-kanban__card--title' style={{backgroundColor: stagedata.color}}>{stage} <span>{stagedata.leads.length}</span></h5>
                                            <div className='app-component-kanban__card--count'>
                                                <Tooltip title={`Add lead into ${stage}`}>
                                                    <IconButton size="small" onClick={() => handleClickOpen(stage)}><AddRoundedIcon className='header-btn-icon' /></IconButton>
                                                </Tooltip>
                                                {stage === "Discovery" ? undefined : <>
                                                    <Tooltip title="More Options">

                                                        <IconButton
                                                            size="small"
                                                            id="basic-button"
                                                            aria-controls={open3 ? 'basic-menu' : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={open3 ? 'true' : undefined}
                                                            onClick={(ie) => {
                                                                setEditingStageIndex(index)
                                                                handleClick2(ie)
                                                            }}
                                                        >
                                                            <MoreVertIcon className='header-btn-icon' />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>}
                                                {index === editingStageIndex && (
                                                    <div>
                                                        <Menu
                                                            id="basic-menu"
                                                            className='custom-menu-item'
                                                            anchorEl={anchorE2}
                                                            open={open3}
                                                            onClose={handleClose2}
                                                            MenuListProps={{
                                                                'aria-labelledby': 'basic-button',
                                                            }}
                                                        >
                                                            <MenuItem
                                                                onClick={() => {
                                                                    setIsAddStageModalOpen(true)
                                                                    setNewStageName(stage.title)
                                                                    setEditingStageIndex(index)
                                                                    setEditstate({ stage, hash: stagedata.hash })
                                                                    setIsUpdate(true)
                                                                    handleClose2()
                                                                }}
                                                            >
                                                                Update
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() => {
                                                                    handleDeleteStage(stagedata.hash); handleClose2()
                                                                }}
                                                            >
                                                                Delete
                                                            </MenuItem>
                                                        </Menu>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <Droppable droppableId={`stage-container-${stage}`}>
                                            {(provided) => (
                                                <div {...provided.droppableProps} ref={provided.innerRef} className='app-component-kanban__card--body'>
                                                    <Scrollbar style={{ height: 'calc(100vh - 260px)' }}>
                                                        <ul className='kanban-client-list'>
                                                            {(  
                                                                stagedata.leads.filter(item => (item.clientemail && item.clientemail.toLowerCase().includes(searchLead.toLowerCase())) || (item.clientname && item.clientname.toLowerCase().includes(searchLead.toLowerCase()))).map(item => {
                                                                    return (
                                                                        <Draggable key={item.hash} draggableId={item.hash} index={index}>
                                                                            {(provided) => (
                                                                                <li
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.dragHandleProps}
                                                                                    {...provided.draggableProps}
                                                                                    className='kanban-client-listitem' 
                                                                                    onClick={() => {
                                                                                        setPopupHash(item.hash)
                                                                                        setIsLeadInfoDrawerOpen(true)
                                                                                    }}>

                                                                                    <div className='kanban-client-title'>
                                                                                        <div className='kanban-client-image-content'>
                                                                                            <div className=''>
                                                                                                <img src={ceo} width="20px" style={{borderRadius:"50%"}}/>
                                                                                            </div>
                                                                                            <div className='client-name'>
                                                                                                {/* <h5>{item.__customer?.firstname}</h5>
                                                                                                <p>{item.__customer?.designation}</p> */}
                                                                                                <h5>{item.clientname}</h5>
                                                                                                <p>{item.clientemail}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='edit-btn'>
                                                                                            <Tooltip title="More Options">
                                                                                                <IconButton
                                                                                                    size="small"
                                                                                                    id="basic-button"
                                                                                                    aria-controls={open2 ? 'basic-menu' : undefined}
                                                                                                    aria-haspopup="true"
                                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                                    onClick={(ie) => {
                                                                                                        ie.stopPropagation();
                                                                                                        setClickedLeadHash(item.hash); 
                                                                                                        setUpdatingClient(index);
                                                                                                        setEditData(item);
                                                                                                        handleClick(ie);
                                                                                                    }}
                                                                                                    
                                                                                                >
                                                                                                    <MoreVertIcon className='header-btn-icon' />
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                            {index === updatingClient && item.hash === clickedLeadHash && (
                                                                                                <div>
                                                                                                    <Menu
                                                                                                        id="basic-menu"
                                                                                                        className='custom-menu-item'
                                                                                                        anchorEl={anchorEl}
                                                                                                        open={open2}
                                                                                                        onClose={(ie) => {handleClose(); ie.stopPropagation();}}
                                                                                                        MenuListProps={{
                                                                                                            'aria-labelledby': 'basic-button',
                                                                                                        }}
                                                                                                    >
                                                                                                        <MenuItem
                                                                                                            onClick={(ie) => {
                                                                                                                ie.stopPropagation()
                                                                                                                handleClickOpened()
                                                                                                                setIsUpdate(true)
                                                                                                                handleClose()
                                                                                                            }}
                                                                                                        >
                                                                                                            Edit
                                                                                                        </MenuItem>
                                                                                                        <MenuItem
                                                                                                            onClick={(ie) => {
                                                                                                                ie.stopPropagation()
                                                                                                                deleteLead(item.hash); handleClose()
                                                                                                            }}
                                                                                                        >
                                                                                                            Delete
                                                                                                        </MenuItem>
                                                                                                    </Menu>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='kanban-client-company'>
                                                                                        <ul>
                                                                                            <li><BusinessOutlined /> <span>{item.company}</span></li>
                                                                                            <li><CalendarTodayIcon /> <span>{new Date(item.createdAt).toDateString()}</span></li>
                                                                                        </ul>
                                                                                    </div>
                                                                                    <div className='tag-names' style={{overflow:"scroll",}}>
                                                                                        {/* <p>Tagname</p>
                                                                                        <p>Tagname</p> */}
                                                                                        {item.tags.map(tag => <p style={{backgroundColor:`${tag.color}`, textWrap:"nowrap", color:"black", borderRadius:"20px",padding:"0.2rem 0.5rem", margin:"0.2rem 0.15rem"}}>{tag.name}</p>)}
                                                                                    </div>
                                                                                </li>)}
                                                                        </Draggable>
                                                                    )
                                                                })
                                                            )}

                                                        </ul>
                                                    </Scrollbar>
                                                </div>)}
                                        </Droppable>

                                    </div>
                                </li>
                            )
                        }) : undefined}
                        <li className='app-component-kanban__listitem'>
                            <div className='app-component-kanban__addstage'>
                                <Button variant='outlined' onClick={handleOpenAddStageModal}> <BiPlusCircle /> Add new stage </Button>
                            </div>
                        </li>
                    </ul>
                </DragDropContext>
            </div>

            {open && (
                <AddLead isPopup={open} setPopup={setOpen} setTriggerRefresh={setTriggerRefresh} stagename={stagename} />
            )}

            {isAddStageModalOpen && (
                <>
                    <div className='app-modal-addstage'>
                        <div className='app-modal-addstage__card'>
                            <div className='app-modal-addstage__cardheader'>
                                <h3>{isUpdate ? "Update Stage" : "New Stage"}</h3>
                                <IconButton size='small' onClick={handleCloseAddStageModal}>
                                    <Close />
                                </IconButton>
                            </div>
                            <div className='app-modal-addstage__cardbody'>
                                <div className='app-form__group'>
                                    <div className='app-form__field'>
                                        <label className='app-form__field--label'>Stage Name</label>
                                        <input
                                            className='app-form__field--input'
                                            type="text"
                                            value={isUpdate ? editstate.stage : newStageName}
                                            placeholder="Enter stage name"
                                            onChange={(e) => isUpdate ? setEditstate(prev => {
                                                const copy = { ...prev }
                                                copy.stage = e.target.value
                                                return copy
                                            }) : setNewStageName(e.target.value)}
                                        />
                                    </div>
                                    <div className='app-form__field'>
                                        <div className='app-component-picker'>
                                            <ul className='app-component-picker__list'>
                                                {availableColors.map((color, index) => (
                                                    <li className='app-component-picker__listitem'>
                                                        <input className='app-component-picker__listitem--input' type='radio' name="stagecolor" id={`stagecolor${index}`} />
                                                        <label
                                                            className='app-component-picker__listitem--label'
                                                            key={index}
                                                            for={`stagecolor${index}`}
                                                            value={selectedColor}
                                                            style={{ backgroundColor: color }}
                                                            onClick={() => handleColorSelection(color)}
                                                        >
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='app-modal-addstage__cardfooter'>
                                <Button className='app-btn-text' onClick={handleCloseAddStageModal}>Cancel</Button>
                                <Button className='app-btn-contained app-btn-primary' variant='contained' onClick={() => isUpdate ? updateStage() : addStage()}>Save</Button>
                            </div>
                        </div>
                    </div>
                </>
            )}


            {/* {isLeadInfoDrawerOpen && selectedLeadIndex !== null && (
                <SwipeableDrawer
                    anchor="right"
                    open={isLeadInfoDrawerOpen}
                    onClose={handleLeadInfoClose}
                >
                    <LeadInformation
                        leadData={selectedLeadIndex}
                        availableColors={availableColors}
                        // onSaveStage={handleSaveStage}
                        data={data}
                        fetchLeads={fetchLeads}
                        setTriggerRefresh={setTriggerRefresh}
                    />
                </SwipeableDrawer>
            )} */}

        </div>
    )
}

export default LeadsPipeView
